/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/canvas/step/batched_stats/:step_type" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasStepBatchedStatsStepType } from "./constants";
import type { EngagementAppGroupIdCanvasStepBatchedStatsStepTypeResult } from "./types";

export const getEngagementAppGroupIdCanvasStepBatchedStatsStepType = reactQueryFetcherAdapter(
  engagementAppGroupIdCanvasStepBatchedStatsStepType,
  (
    signal: AbortSignal,
    appGroupId: string,
    stepType: string,
    stepIds: string[],
    start: number,
    end: number
  ): Promise<EngagementAppGroupIdCanvasStepBatchedStatsStepTypeResult> => {
    return fetch(
      `/engagement/${appGroupId}/canvas/step/batched_stats/${stepType}`,
      "GET",
      { start, end, step_ids: stepIds },
      { signal }
    );
  }
);
